// 빈 문자열/undefined/깨진 JSON이 들어와도 throw하지 않고 fallback(기본 [])을 반환한다.
// (JSON.parse("") → "Unexpected end of JSON input" 크래시 방지)
export const parseJSON = <T>(
  data?: string | null,
  fallback: T = [] as unknown as T,
): T => {
  if (!data) return fallback;

  try {
    return JSON.parse(data) as T;
  } catch {
    return fallback;
  }
};
